export default __webpack_public_path__ + "static/media/icons.76da979b.png";